import BASKET1 from "../../../assets/multipurpose.webp";
// import BASKET2 from "../../../assets/multipurpose.webp";
import BASKET3 from "../../../assets/cup-saucer.webp";
import BASKET4 from "../../../assets/plate.webp";
import BASKET5 from "../../../assets/thali.webp";
import BASKET6 from "../../../assets/partition-basket.webp";
import BASKET7 from "../../../assets/vegetable-basket.webp";
import BASKET8 from "../../../assets/bottel-basket.webp";
import BASKET9 from "../../../assets/sheet-cutlery.webp";
import BASKET10 from "../../../assets/sheet-cutlery-box.webp";
import BASKET11 from "../../../assets/cutlery.webp";
import BASKET12 from "../../../assets/grain-trolly.webp";
import BASKET13 from "../../../assets/hanging-corner-single-shelf.webp";
import BASKET14 from "../../../assets/single-self.webp";
import BASKET15 from "../../../assets/carousel-3&4.webp";
import BASKET16 from "../../../assets/dee-tray.webp";
import BASKET17 from "../../../assets/doble-shelf.webp";
import BASKET18 from "../../../assets/triple-shelf.webp";
import BASKET19 from "../../../assets/laddlecraddle.webp";
import BASKET20 from "../../../assets/kitchens-keeper.webp";
import BASKET21 from "../../../assets/spoone-holder.webp";
import BASKET22 from "../../../assets/glass-holder-basket.webp";
import BASKET23 from "../../../assets/gtpt-wire.webp";
import BASKET24 from "../../../assets/bin-holder.webp";
import BASKET25 from "../../../assets/use-me-shutter.webp";
import BASKET26 from "../../../assets/bucket-bin.webp";
import BASKET27 from "../../../assets/paddle-performated.webp";
import BASKET28 from "../../../assets/hanging-corner-2-Shelf.webp";

export const multiuseBaskets = [
  {
  code: "MB-01",
  name: "PLAIN BASKET - SLIMLINE",
  category: "multiuse-basket",

  short:
    "Plain Basket - Slimline is a compact and efficient storage solution designed for narrow modular kitchen cabinets. Made from high-quality stainless steel with a rust-resistant finish, it ensures durability, hygiene, and easy organization of kitchen essentials.",

  features: [
    "Width: 9 | 12 | 15 | 17 | 19 | 21",
    "Depth: 16 | 20 | 22 | 24",
    "Height: 4 | 6 | 8",
    "Loading Capacity: 25kg",
    "Material: Annealed Stainless Steel",
    "Finish: Nickel Chrome",
    "Rust-resistant body",
    "Open design for air circulation",
    "Strong and durable structure"
  ],

  /* ✅ PRICE */
  price: "₹1656",
  oldPrice: "₹4500",

  /* ✅ SKU + STOCK */
  sku: "FLM 01",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET1,
  

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/_VX9vXCYkFs?si=Bp3fHcxKkz8CUNxH",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Plain%20Basket%20Slimline%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Kitchen Cabinet Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Slimline Basket", code: "FLM 01", size: "15.20.4", finish: "Nickel Chrome" },
     { item: "Slimline Basket", code: "FLM 02", size: "15.20.6", finish: "Nickel Chrome" },
      { item: "Slimline Basket", code: "FLM 03", size: "15.20.8", finish: "Nickel Chrome" },
     
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Plain Basket - Slimline?",
      answer:
        "It is a slim storage basket designed for narrow kitchen cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in modular kitchens for organizing utensils and groceries."
    },
    {
      question: "What are its advantages?",
      answer:
        "It maximizes space, improves organization, and provides easy access."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store jars, containers, spices, and kitchen essentials."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from stainless steel with a rust-resistant finish."
    }
  ]
},

// {
//   code: "MB-02",
//   name: "LARGE UTENSILS BASKET",
//   category: "multiuse-basket",

//   short:
//     "Large Utensils Basket is a heavy-duty storage solution designed for organizing big kitchen items like pots, pans, and cookware. Made from high-quality stainless steel with a rust-resistant finish, it ensures durability, strength, and efficient space utilization in modular kitchens.",

//   features: [
//     "Width: 24 | 27 | 32",
//     "Depth: 20",
//     "Height: 4 | 6 | 8",
//     "Loading Capacity: 25kg",
//     "Material: Annealed Stainless Steel",
//     "Finish: Nickel Chrome",
//     "Spacious design for large utensils",
//     "Strong load-bearing capacity",
//     "Rust-resistant and durable",
//     "Easy visibility and access"
//   ],

//   /* ✅ PRICE */
//   price: "₹2686",
//   oldPrice: "₹5800",

//   /* ✅ SKU + STOCK */
//   sku: "FLM 04",
//   stock: "In Stock",

//   /* ✅ IMAGES */
//   mainImage: BASKET2,


//   /* ✅ VIDEO */
//   video: "https://www.youtube.com/embed/2Py1jFLG67U",

//   /* ✅ LINKS */
//   catalogue: "/Slimline Price List-2026.pdf",
//   inquiry:
//     "https://wa.me/919650100908?text=Large%20Utensils%20Basket%20Inquiry",

//   /* ✅ SPECIFICATIONS */
//   specifications: [
//     { label: "Material", value: "Stainless Steel" },
//     { label: "Finish", value: "Nickel Chrome" },
//     { label: "Load Capacity", value: "25 Kg" },
//     { label: "Application", value: "Kitchen Cabinet Storage" }
//   ],

//   /* ✅ SPEC TABLE */
//   specTable: [
//     { item: "Large Basket", code: "FLM 04", size: "17.20.4", finish: "Nickel Chrome" },
//      { item: "Large Basket", code: "FLM 05", size: "17.20.6", finish: "Nickel Chrome" },
//       { item: "Large Basket", code: "FLM 06", size: "17.20.8", finish: "Nickel Chrome" },
//   ],

//   /* ✅ FAQ */
//   faq: [
//     {
//       question: "What is a Large Utensils Basket?",
//       answer:
//         "It is a storage basket designed for organizing large kitchen items like pots and pans."
//     },
//     {
//       question: "Where can it be used?",
//       answer:
//         "It is used in modular kitchen cabinets for storing heavy utensils."
//     },
//     {
//       question: "What are its advantages?",
//       answer:
//         "It provides better organization, supports heavy load, and improves accessibility."
//     },
//     {
//       question: "What can be stored in it?",
//       answer:
//         "You can store pots, pans, pressure cookers, and other large utensils."
//     },
//     {
//       question: "Is it durable?",
//       answer:
//         "Yes, it is made from high-quality stainless steel with rust resistance."
//     }
//   ]
// },
{
  code: "MB-03",
  name: "CUP & SAUCER BASKET",
  category: "multiuse-basket",

  short:
    "Cup & Saucer Basket is a smart storage solution designed to organize cups, saucers, and small crockery efficiently in modular kitchens. Made from high-quality stainless steel with a rust-resistant finish, it ensures durability, hygiene, and safe storage with easy accessibility.",

  features: [
    "Width: 15 | 17 | 19 | 21",
    "Depth: 20",
    "Height: 4",
    "Loading Capacity: 25kg",
    "Material: Annealed Stainless Steel",
    "Finish: Nickel Chrome",
    "Dedicated slots for cups and saucers",
    "Rust-resistant body",
    "Smart partition for safe storage",
    "Easy access and visibility",
    "Keeps kitchen organized"
  ],

  /* ✅ PRICE */
  price: "₹3198",
  oldPrice: "₹4800",

  /* ✅ SKU + STOCK */
  sku: "FLM 40",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET3,


  /* ✅ VIDEO (SHORTS → EMBED FIXED) */
  video: "https://www.youtube.com/embed/_VX9vXCYkFs",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Cup%20%26%20Saucer%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Kitchen Cabinet Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Cup & Saucer Basket", code: "FLM 37", size: "15.20.4", finish: "Nickel Chrome" },
    { item: "Cup & Saucer Basket", code: "FLM 38", size: "15.20.6", finish: "Nickel Chrome" },
    { item: "Cup & Saucer Basket", code: "FLM 39", size: "15.20.8", finish: "Nickel Chrome" },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Cup & Saucer Basket?",
      answer:
        "It is a storage basket designed to hold cups and saucers neatly in kitchen cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in modular kitchens and cabinets for organizing drinkware."
    },
    {
      question: "What are its advantages?",
      answer:
        "It prevents damage, improves organization, and provides easy access."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store cups, mugs, saucers, and small teapots."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from rust-resistant stainless steel."
    }
  ]
},


 {
  code: "MB-04",
  name: "PLATE BASKET",
  category: "multiuse-basket",

  short:
    "Plate Basket is a smart storage solution designed to organize plates neatly inside modular kitchen cabinets. Made from high-quality stainless steel with a rust-resistant finish, it ensures durability, hygiene, and easy access while keeping kitchen space well-arranged.",

  features: [
    "Width: 9 | 12 | 15 | 17 | 19 | 21 | 24 | 27 | 32",
    "Depth: 16 | 20 | 22 | 24",
    "Height: 6",
    "Loading Capacity: 25kg",
    "Material: Annealed Stainless Steel",
    "Finish: Nickel Chrome",
    "Ideal for organizing plates and dinnerware",
    "Open-wire design for ventilation",
    "Strong and durable structure",
    "Keeps kitchen neat and organized"
  ],

  /* ✅ PRICE */
  price: "₹3214",
  oldPrice: "₹4000",

  /* ✅ SKU + STOCK */
  sku: "FLM 46",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET4,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Plate%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Kitchen Cabinet Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Plate Basket", code: "FLM - 46", size: "15.20.6", finish: "Nickel Chrome" },
     { item: "Plate Basket", code: "FLM - 47", size: "17.20.6", finish: "Nickel Chrome" },
      { item: "Plate Basket", code: "FLM - 48", size: "19.20.6", finish: "Nickel Chrome" },
       { item: "Plate Basket", code: "FLM - 49", size: "21.20.6", finish: "Nickel Chrome" },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Plate Basket?",
      answer:
        "It is a storage basket used to organize plates in kitchen cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in modular kitchens and cabinets for storing dinnerware."
    },
    {
      question: "What are its advantages?",
      answer:
        "It prevents scratches, improves organization, and saves space."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store plates, saucers, and flat kitchenware."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from rust-resistant stainless steel."
    }
  ]
},



 {
  code: "MB-05",
  name: "THALI BASKET",
  category: "multiuse-basket",

  short:
    "Thali Basket is a smart storage solution designed to organize plates, thalis, and flat kitchenware efficiently in modular kitchen cabinets. Made from high-quality stainless steel with a rust-resistant finish, it ensures durability, hygiene, and easy access while preventing damage.",

  features: [
    "Width: 9 | 12 | 15 | 17 | 19 | 21 | 24 | 27 | 32",
    "Depth: 16 | 20 | 22 | 24",
    "Height: 8",
    "Loading Capacity: 25kg",
    "Material: Annealed Stainless Steel",
    "Finish: Nickel Chrome",
    "Vertical slots for plates and thalis",
    "Rust-resistant body",
    "Prevents scratches and damage",
    "Easy visibility and access",
    "Keeps kitchen organized"
  ],

  /* ✅ PRICE */
  price: "₹3800",
  oldPrice: "₹5200",

  /* ✅ SKU + STOCK */
  sku: "MB-05",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET5,
  
  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Thali%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Kitchen Cabinet Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Thali Basket", code: "FLM 55", size: "15.20.8", finish: "Nickel Chrome" },
    { item: "Thali Basket", code: " FLM 56", size: "17.20.8", finish: "Nickel Chrome" },
    { item: "Thali Basket", code: " FLM 57", size: "19.20.8", finish: "Nickel Chrome" },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Thali Basket?",
      answer:
        "It is a storage basket used to organize thalis and plates in kitchen cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in modular kitchens and cabinets for storing flat cookware."
    },
    {
      question: "What are its advantages?",
      answer:
        "It prevents scratches, improves organization, and saves space."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store thalis, plates, trays, and flat kitchen items."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from rust-resistant stainless steel."
    }
  ]
},




 {
  code: "MB-06",
  name: "PARTITION BASKET",
  category: "multiuse-basket",

  short:
    "Partition Basket is a smart storage solution designed to organize kitchen items efficiently with multiple sections. Made from high-quality stainless steel with a rust-resistant finish, it ensures durability, hygiene, and easy access while keeping items neatly separated.",

  features: [
    "Width: 9 | 12 | 15 | 17 | 19 | 21",
    "Depth: 16 | 20 | 22 | 24",
    "Height: 4 | 6 | 8",
    "Loading Capacity: 25kg",
    "Material: Annealed Stainless Steel",
    "Finish: Nickel Chrome",
    "Multiple partitions for organized storage",
    "Keeps items separated and secure",
    "Rust-resistant and durable",
    "Easy visibility and access"
  ],

  /* ✅ PRICE */
  price: "₹3400",
  oldPrice: "₹4700",

  /* ✅ SKU + STOCK */
  sku: "",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET6,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Partition%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Kitchen Cabinet Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Partition Basket", code: "", size: "", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Partition Basket?",
      answer:
        "It is a storage basket with sections to organize kitchen items separately."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in kitchen drawers and cabinets for organizing utensils and tools."
    },
    {
      question: "What are its advantages?",
      answer:
        "It prevents clutter, improves organization, and makes items easy to find."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store cutlery, lids, containers, and small kitchen items."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from rust-resistant stainless steel."
    }
  ]
},



  {
  code: "MB-07",
  name: "VEGETABLE BASKET",
  category: "multiuse-basket",

  short:
    "Vegetable Basket is a practical storage solution designed to keep vegetables fresh and organized inside modular kitchen cabinets. Made from high-quality stainless steel with a rust-resistant finish, it ensures durability, hygiene, and proper air circulation for longer freshness.",

  features: [
    "Width: 15 | 17 | 19 | 21",
    "Depth: 20",
    "Height: 6",
    "Loading Capacity: 25kg",
    "Material: Annealed Stainless Steel",
    "Finish: Nickel Chrome",
    "Ventilated design for better airflow",
    "Rust-resistant body",
    "Keeps vegetables fresh longer",
    "Easy access and organization"
  ],

  /* ✅ PRICE */
  price: "₹10718",
  oldPrice: "₹11600",

  /* ✅ SKU + STOCK */
  sku: "FLM 121",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET7,
 
  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Vegetable%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Kitchen Storage / Vegetable Organizer" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Vegetable Basket", code: "FLM 121", size: "15\" / 17\" / 19\" / 21\"", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Vegetable Basket?",
      answer:
        "It is a storage basket designed to keep vegetables organized and fresh."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in kitchen cabinets and pantry storage areas."
    },
    {
      question: "What are its advantages?",
      answer:
        "It improves airflow, keeps vegetables fresh, and saves space."
    },
    {
      question: "What can be stored in it?",
      answer:
        "You can store vegetables, fruits, onions, and potatoes."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from rust-resistant stainless steel."
    }
  ]
},


  {
  code: "MB-08",
  name: "BOTTLE BASKET",
  category: "multiuse-basket",

  short:
    "Slimline Bottle Basket is designed to store bottles, jars, and tall containers neatly inside kitchen cabinets. Made from high-quality stainless steel with a rust-resistant finish, it ensures durability and hygiene. Its sturdy structure and smart layout keep bottles secure, organized, and easily accessible.",

  features: [
    "Width : 15 | 17 | 19 | 21",
    "Depth : 20",
    "Height : 6",
    "Loading Capacity : 25kg",
    "Material : Annealed Stainless Steel",
    "Finish : Nickel Chrome",
    "Ideal for bottles and tall containers",
    "Rust-resistant stainless steel body",
    "Strong and stable structure"
  ],

  /* ✅ PRICE */
  price: "₹4167",
  oldPrice: "₹4500",

  /* ✅ SKU + STOCK */
  sku: "FLM 125",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET8,
 

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Bottle%20Basket",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Kitchen Cabinet / Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Bottle Basket", code: "FLM 125", size: "15 / 17 / 19 / 21", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Bottle Basket?",
      answer:
        "Bottle Basket is a kitchen storage basket designed to hold bottles, jars, and tall containers in an organized and secure manner."
    },
    {
      question: "Where is the Bottle Basket used?",
      answer:
        "It is commonly installed in kitchen cabinets, pantries, or modular racks to store bottles, sauces, oils, and other liquid containers."
    },
    {
      question: "What are the advantages of a Bottle Basket?",
      answer:
        "It keeps bottles upright and organized, prevents tipping, and maximizes storage space in cabinets."
    },
    {
      question: "What items can be stored in a Bottle Basket?",
      answer:
        "You can store water bottles, oil bottles, sauce bottles, tall jars, and other liquid containers safely and neatly."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality stainless steel with a rust-resistant finish for long-lasting use."
    }
  ]
},



  {
  code: "MB-09",
  name: "SHEET CUTLERY",
  category: "multiuse-basket",

  short:
    "Slimline Sheet Cutlery Basket is designed to organize spoons, forks, knives, and small kitchen tools neatly inside drawers. Made from high-quality stainless steel sheet with a rust-resistant finish, it ensures durability and hygiene. Its compact, sectioned design keeps cutlery well-arranged, safe, and easily accessible.",

  features: [
    "Width : 9 | 12 | 15 | 17 | 19 | 21",
    "Depth : 20",
    "Height : 4",
    "Loading Capacity : 25kg",
    "Material : Annealed Stainless Steel",
    "Finish : Nickel Chrome",
    "Sectioned layout for cutlery organization",
    "Rust-resistant stainless steel sheet body",
    "Compact and space-efficient design"
  ],

  /* ✅ PRICE */
  price: "₹5439",
  oldPrice: "₹6900",

  /* ✅ SKU + STOCK */
  sku: "FLM 82",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET9,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Sheet%20Cutlery%20Basket",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel Sheet" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Drawer / Kitchen Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Sheet Cutlery Basket", code: "FLM 82", size: " 15 / 17 / 19 / 21 / 24", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Sheet Cutlery Basket?",
      answer:
        "Sheet Cutlery Basket is a kitchen storage basket designed to organize cutlery, knives, and small kitchen tools in a flat, divided layout."
    },
    {
      question: "Where is the Sheet Cutlery Basket used?",
      answer:
        "It is commonly installed in kitchen drawers or cabinets to keep spoons, forks, knives, and other utensils organized."
    },
    {
      question: "What are the advantages of a Sheet Cutlery Basket?",
      answer:
        "It separates utensils neatly, prevents clutter, maximizes space, and makes items easy to access."
    },
    {
      question: "What items can be stored in a Sheet Cutlery Basket?",
      answer:
        "You can store spoons, forks, knives, ladles, and small kitchen tools in an organized way."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality stainless steel with a rust-resistant finish for long-lasting use."
    }
  ]
},



 {
  code: "MB-10",
  name: "Cutlery Perforated",
  category: "multiuse-basket",

  short:
    "Slimline Box Cutlery Basket is designed to store spoons, forks, knives, and small kitchen tools in a neat and organized manner. Made from high-quality stainless steel with a rust-resistant finish, it ensures durability and hygiene. Its box-style compartments keep cutlery separated, secure, and easily accessible inside drawers.",

  features: [
    "Width : 15 | 17 | 19 | 21",
    "Depth : 20",
    "Height : 4",
    "Loading Capacity : 25kg",
    "Material : Annealed Stainless Steel",
    "Finish : Nickel Chrome",
    "Box compartments for organized cutlery",
    "Rust-resistant stainless steel body",
    "Keeps items separated and secure"
  ],

  /* ✅ PRICE */
  price: "₹4660",
  oldPrice: "₹4800",

  /* ✅ SKU + STOCK */
  sku: "FLM 64",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET10,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Box%20Cutlery%20Basket",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Drawer / Kitchen Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Box Cutlery Basket", code: "FLM 65", size: "15 / 17 / 19 / 21", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Box Cutlery Basket?",
      answer:
        "Box Cutlery Basket is a kitchen storage basket designed to organize cutlery and small utensils in a box-shaped container for neat arrangement."
    },
    {
      question: "Where is the Box Cutlery Basket used?",
      answer:
        "It is commonly installed in kitchen drawers, cabinets, or modular racks to store spoons, forks, knives, and other small tools."
    },
    {
      question: "What are the advantages of a Box Cutlery Basket?",
      answer:
        "It keeps cutlery organized, prevents clutter, and ensures easy access while maximizing storage space."
    },
    {
      question: "What items can be stored in a Box Cutlery Basket?",
      answer:
        "You can store spoons, forks, knives, ladles, and small kitchen tools neatly and safely."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality stainless steel with a rust-resistant finish for long-lasting use."
    }
  ]
},



  {
  code: "MB-11",
  name: "CUTLERY BASKET (WIRE)",
  category: "multiuse-basket",

  short:
    "Slimline Wire Cutlery Basket is designed to organize spoons, forks, knives, and small utensils efficiently inside kitchen drawers or cabinets. Made from high-quality stainless steel wire with a rust-resistant finish, it ensures durability and hygiene. The open wire design provides ventilation, visibility, and easy access.",

  features: [
    "Width : 9 | 12 | 15 | 17 | 19 | 21",
    "Depth : 20",
    "Height : 4",
    "Loading Capacity : 25kg",
    "Material : Annealed Stainless Steel",
    "Finish : Nickel Chrome",
    "Open wire design for better visibility",
    "Rust-resistant stainless steel wire body",
    "Allows airflow and water drainage"
  ],

  /* ✅ PRICE */
  price: "₹4174",
  oldPrice: "₹4500",

  /* ✅ SKU + STOCK */
  sku: "FLM 73",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET11,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Cutlery%20Basket%20Wire",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel Wire" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Application", value: "Drawer / Kitchen Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Cutlery Basket (Wire)", code: "FLM 73", size: " 15 / 17 / 19 / 21", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Cutlery Basket (Wire)?",
      answer:
        "It is a wire-frame kitchen basket designed to organize spoons, forks, knives, and small utensils with proper airflow and easy access."
    },
    {
      question: "Where is the Cutlery Basket (Wire) used?",
      answer:
        "It is commonly used in kitchen drawers, cabinets, or countertops to store cutlery efficiently."
    },
    {
      question: "What are the advantages of a Cutlery Basket (Wire)?",
      answer:
        "It provides ventilation, prevents water buildup, keeps utensils organized, and makes cleaning easier."
    },
    {
      question: "What items can be stored in it?",
      answer:
        "You can store spoons, forks, knives, ladles, and other small kitchen tools neatly."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality stainless steel with a rust-resistant finish for long-term use."
    }
  ]
},



//   {
//     code: "MB-012",
//     name: "GRAIN TROLLEY WITH WHEEL MECHANISM FRAME  ",
//     category: "multiuse-basket",
//     short:
//       "Slimline Grain Trolley with Wheel Mechanism Frame is designed for convenient storage of grains and groceries inside kitchen cabinets. Built with a strong metal frame and smooth-rolling wheels, it allows easy pull-out access. Durable, rust-resistant construction ensures long-lasting performance and organized storage.",
//     features: [
//       "Width :15 | 17 | 19 | 21 ",
//       "Depth :  20 ",
//       "Height :  10",
//       "Loading Capacity : 25kg ",
//       "Material : Annealed Stainless Steel",
//       "Finish : Nickel Chrome",
//       "Smooth wheel mechanism for easy movement",
//       "Strong and durable metal frame",
//       "Ideal for storing grains and groceries",
//     ],
//     faq: [
//   {
//     question: "What is a Grain Trolley with Wheel Mechanism Frame?",
//     answer:
//       "Grain Trolley with Wheel Mechanism Frame is a movable storage trolley designed to store grains, pulses, and other dry food items, with wheels for easy mobility."
//   },
//   {
//     question: "Where is the Grain Trolley with Wheel Mechanism Frame used?",
//     answer:
//       "It is commonly used in kitchens, pantries, or storage rooms to organize and transport grains and bulk dry items efficiently."
//   },
//   {
//     question: "What are the advantages of a Grain Trolley with Wheel Mechanism Frame?",
//     answer:
//       "It provides easy mobility, maximizes storage space, keeps grains organized, and allows convenient access to stored items."
//   },
//   {
//     question: "What items can be stored in a Grain Trolley with Wheel Mechanism Frame?",
//     answer:
//       "You can store grains, pulses, rice, flour, and other dry food items safely and neatly."
//   }
// ],
//     image: BASKET12,
//   },
  {
  code: "MB-012",
  name: "GRAIN TROLLEY WITH WHEEL MECHANISM FRAME",
  category: "multiuse-basket",

  short:
    "Slimline Grain Trolley with Wheel Mechanism Frame is designed for convenient storage of grains and groceries inside kitchen cabinets. Built with a strong metal frame and smooth-rolling wheels, it allows easy pull-out access. Durable, rust-resistant construction ensures long-lasting performance and organized storage.",

  features: [
    "Width : 15 | 17 | 19 | 21",
    "Depth : 20",
    "Height : 10",
    "Loading Capacity : 25kg",
    "Material : Annealed Stainless Steel",
    "Finish : Nickel Chrome",
    "Smooth wheel mechanism for easy movement",
    "Strong and durable metal frame",
    "Ideal for storing grains and groceries"
  ],

  /* ✅ PRICE */
  price: "₹4636",
  oldPrice: "₹5200",

  /* ✅ SKU + STOCK */
  sku: "FLM 87",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET12,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Grain%20Trolley",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Load Capacity", value: "25 Kg" },
    { label: "Mechanism", value: "Wheel-Based Pull-Out System" },
    { label: "Application", value: "Kitchen Cabinet / Pantry Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Grain Trolley", code: "FLM 87", size: "15 / 17 / 19 / 21", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Grain Trolley with Wheel Mechanism Frame?",
      answer:
        "It is a movable kitchen storage trolley designed to store grains, pulses, and groceries with a smooth wheel mechanism for easy access."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is commonly used in kitchen cabinets, pantries, or storage areas for organizing dry food items."
    },
    {
      question: "What are the advantages?",
      answer:
        "It offers easy pull-out movement, better organization, and efficient use of storage space."
    },
    {
      question: "What items can be stored?",
      answer:
        "You can store rice, flour, pulses, grains, and other dry groceries."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality stainless steel with a rust-resistant finish for long-lasting use."
    }
  ]
},




{
  code: "MB-013",
  name: "HANGING CORNER SINGLE",
  category: "multiuse-basket",

  short:
    "Slimline Hanging Corner is a smart and space-saving storage solution designed to utilize unused corner areas in kitchens, bathrooms, or cabinets. Made from high-quality materials with a sturdy structure, it provides reliable support for daily essentials while keeping the space neat and organized. Its compact design fits perfectly into corners, maximizing storage without occupying extra space.",

  features: [
    "Space-saving corner design for efficient storage",
    "Strong and durable construction",
    "Easy wall-mount / hanging installation",
    "Ideal for kitchen, bathroom, and storage use",
    "Modern design for clean and organized look",
    "Rust-resistant and long-lasting finish"
  ],

  /* ✅ PRICE */
  price: "₹1551",
  oldPrice: "₹2600",

  /* ✅ SKU + STOCK */
  sku: "FLM 185",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET13,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Hanging%20Corner",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel / Metal" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Wall Mounted Corner Shelf" },
    { label: "Application", value: "Kitchen / Bathroom / Storage" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Hanging Corner", code: "FLM 185 ", size: "(1SHELF)", finish: "Nickel Chrome" },
    { item: "Hanging Corner", code: "FLM 186 ", size: "(2SHELF)", finish: "Nickel Chrome" },
    { item: "Hanging Corner", code: "FLM 187 ", size: "(3SHELF)", finish: "Nickel Chrome" },
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Hanging Corner?",
      answer:
        "It is a corner-mounted storage shelf designed to utilize unused corner space for organizing kitchen or household items."
    },
    {
      question: "Where can it be used?",
      answer:
        "It can be used in kitchens, bathrooms, or storage areas to organize daily essentials."
    },
    {
      question: "What are the advantages?",
      answer:
        "It saves space, keeps items organized, and utilizes corner areas efficiently."
    },
    {
      question: "What items can be stored?",
      answer:
        "You can store jars, containers, toiletries, spices, and small household items."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality material with a rust-resistant finish for long-term use."
    }
  ]
},
  {
  code: "MB-014",
  name: "HANGING SINGLE SHELF",
  category: "multiuse-basket",

  short:
    "Slimline Hanging Single Shelf is a practical and space-saving storage solution designed for kitchens, cabinets, and utility areas. Made from high-quality durable material, it provides a sturdy platform for storing everyday essentials while keeping spaces neat and organized. Its hanging design allows easy installation and quick access, making it ideal for modular kitchen setups.",

  features: [
    "Space-saving hanging design",
    "Strong and durable construction",
    "Easy to install and use",
    "Ideal for kitchen and storage use",
    "Keeps items organized and accessible",
    "Modern and clean design"
  ],

  /* ✅ PRICE */
  price: "₹1551",
  oldPrice: "₹2100",

  /* ✅ SKU + STOCK */
  sku: "FLM 185",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET14,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Hanging%20Single%20Shelf",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel / Metal" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Wall Mounted Shelf" },
    { label: "Application", value: "Kitchen / Storage / Utility" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Hanging Single Shelf", code: "MB14", size: "Standard", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Hanging Single Shelf?",
      answer:
        "It is a wall-mounted storage shelf designed to organize kitchen and household items efficiently."
    },
    {
      question: "Where can it be used?",
      answer:
        "It can be used in kitchens, cabinets, bathrooms, or storage areas."
    },
    {
      question: "What are the advantages?",
      answer:
        "It saves space, improves organization, and provides easy access to daily essentials."
    },
    {
      question: "What items can be stored?",
      answer:
        "You can store jars, containers, spices, and small kitchen tools."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality material with a long-lasting finish."
    }
  ]
},


{
  code: "MB-017",
  name: "HANGING DOUBLE SHELF",
  category: "multiuse-basket",

  short:
    "Slimline Hanging Double Shelf is a smart and space-efficient storage solution designed to provide extra storage in kitchens, cabinets, or utility areas. Featuring two sturdy shelves, it allows better organization of kitchen essentials such as containers, spices, or small utensils. Made from high-quality durable material, it ensures strength and stability for everyday use while maximizing vertical space.",

  features: [
    "Double-shelf design for extra storage",
    "Strong and durable construction",
    "Space-saving vertical hanging design",
    "Ideal for kitchen and storage use",
    "Keeps items organized and easily accessible",
    "Modern and clean finish"
  ],

  /* ✅ PRICE */
  price: "₹2520",
  oldPrice: "₹3100",

  /* ✅ SKU + STOCK */
  sku: "FLM 194",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET17,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=I%20am%20interested%20in%20Hanging%20Double%20Shelf",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel / Metal" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Double Shelf Wall Mounted" },
    { label: "Application", value: "Kitchen / Storage / Utility" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Hanging Double Shelf", code: "FLM 194", size: "", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Hanging Double Shelf?",
      answer:
        "It is a wall-mounted storage unit with two shelves designed to organize kitchen and household items efficiently."
    },
    {
      question: "Where can it be used?",
      answer:
        "It can be used in kitchens, cabinets, bathrooms, or storage areas."
    },
    {
      question: "What are the advantages?",
      answer:
        "It increases storage space, saves counter area, and keeps items well organized."
    },
    {
      question: "What items can be stored?",
      answer:
        "You can store jars, containers, spices, and small kitchen tools across the two shelves."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality material with a long-lasting finish."
    }
  ]
},

  {
  code: "MB-015",
  name: "CAROUSEL (3/4)",
  category: "multiuse-basket",

  short:
    "Carousel (3/4) is a smart corner storage solution designed for modular kitchens. Its rotating mechanism allows easy access to items stored deep inside corner cabinets. The 3/4 circular design maximizes unused space while ensuring smooth movement, making it ideal for organizing kitchen essentials efficiently.",

  features: [
    "3/4 circular design for efficient corner cabinet storage",
    "Smooth rotating mechanism for easy access",
    "Maximizes unused corner space",
    "Strong and durable construction",
    "Ideal for storing utensils, containers, and groceries",
    "Suitable for modular kitchen corner cabinets"
  ],

  /* ✅ PRICE */
  price: "₹0",
  oldPrice: "₹0",

  /* ✅ SKU + STOCK */
  sku: "FLM 133-136",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET15,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Carousel%203/4%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Type", value: "Corner Carousel (3/4)" },
    { label: "Material", value: "Metal / SS (varies by model)" },
    { label: "Application", value: "Modular Kitchen Corner Cabinet" },
    { label: "Sizes", value: "18 | 20 | 22 | 24 | 26 | 28 | 30" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Carousel", code: "PRM 136", size: "18 \"", finish: "" },
    { item: "Carousel", code: "PRM 137", size: "20 \"", finish: "" },
    { item: "Carousel", code: "PRM 138", size: "22 \"", finish: "" },
    { item: "Carousel", code: "PRM 139", size: "24 \"", finish: "" },
   
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Carousel (3/4)?",
      answer:
        "It is a rotating storage system designed for corner kitchen cabinets to provide easy access to stored items."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in modular kitchen corner cabinets to utilize deep corner space efficiently."
    },
    {
      question: "What is its main benefit?",
      answer:
        "It allows smooth rotation and easy access to items stored at the back of the cabinet."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong and durable materials for long-lasting performance."
    },
    {
      question: "What items can be stored?",
      answer:
        "It can store utensils, pots, containers, groceries, and other kitchen essentials."
    }
  ]
},




 {
  code: "MB-016",
  name: "DEE TRAY",
  category: "multiuse-basket",

  short:
    "Dee Tray is a smart corner storage solution designed for modular kitchen cabinets. Its D-shaped design efficiently utilizes corner spaces while allowing easy access to stored items. Built with durable materials, it ensures stability, smooth usage, and organized storage of kitchen essentials.",

  features: [
    "D-shaped design for corner cabinet optimization",
    "Maximizes unused corner space",
    "Strong and durable construction",
    "Smooth access to stored items",
    "Ideal for storing utensils, containers, and groceries",
    "Suitable for modular kitchen corner cabinets"
  ],

  /* ✅ PRICE */
  price: "₹5458",
  oldPrice: "₹6000",

  /* ✅ SKU + STOCK */
  sku: "FLM 147-153",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET16,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Dee%20Tray%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Type", value: "Corner Dee Tray" },
    { label: "Material", value: "Metal / SS (varies by model)" },
    { label: "Application", value: "Modular Kitchen Corner Cabinet" },
    { label: "Sizes", value: "18 | 20 | 22 | 24 | 26 | 28 | 30" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Dee Tray", code: "FLM  147", size: "18", finish: "Standard" },
    { item: "Dee Tray", code: "FLM  148", size: "20", finish: "Standard" },
    { item: "Dee Tray", code: "FLM  149", size: "22", finish: "Standard" },
    { item: "Dee Tray", code: "FLM  150", size: "24", finish: "Standard" }, { item: "Dee Tray", code: "FLM  151", size: "26", finish: "Standard" },
    { item: "Dee Tray", code: "FLM  152", size: "28", finish: "Standard" },
    { item: "Dee Tray", code: "FLM  153", size: "30", finish: "Standard" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Dee Tray?",
      answer:
        "It is a D-shaped storage tray designed for corner kitchen cabinets to efficiently utilize space."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in modular kitchen corner cabinets for better storage and accessibility."
    },
    {
      question: "What is its main benefit?",
      answer:
        "It maximizes corner space and allows easy access to items stored inside cabinets."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong and durable materials for long-lasting use."
    },
    {
      question: "What items can be stored?",
      answer:
        "It can store utensils, containers, groceries, and other kitchen essentials."
    }
  ]
},


 {
  code: "MB-018",
  name: "TRIPLE SHELF",
  category: "multiuse-basket",

  short:
    "Triple Shelf is a smart and space-saving storage solution designed for modular kitchens and cabinets. Featuring three sturdy shelves, it allows efficient vertical storage of kitchen essentials such as containers, jars, and utensils. Built with durable materials, it ensures stability, easy access, and organized storage while enhancing overall kitchen functionality.",

  features: [
    "Three-shelf design for maximum vertical storage",
    "Strong and durable construction",
    "Efficient organization of kitchen essentials",
    "Easy access to stored items",
    "Ideal for cabinets, kitchens, and storage areas",
    "Space-saving and practical design"
  ],

  /* ✅ PRICE */
  price: "₹4026",
  oldPrice: "₹5000",

  /* ✅ SKU + STOCK */
  sku: "FLM 195",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET18,


  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Triple%20Shelf%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Type", value: "Triple Shelf" },
    { label: "Material", value: "Metal / SS (varies by model)" },
    { label: "Application", value: "Kitchen / Cabinet / Storage Unit" },
    { label: "Shelves", value: "3 Tier" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Triple Shelf", code: "FLM 195", size: "", finish: "" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Triple Shelf?",
      answer:
        "It is a three-tier storage unit designed to organize kitchen essentials in a compact vertical space."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in modular kitchens, cabinets, and storage areas for better organization."
    },
    {
      question: "What is its main benefit?",
      answer:
        "It maximizes vertical storage space and keeps items easily accessible."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong and durable materials for long-lasting performance."
    },
    {
      question: "What items can be stored?",
      answer:
        "It can store jars, containers, utensils, spices, and other kitchen essentials."
    }
  ]
},

{
  code: "MB-019",
  name: "LADDLE CRADDLE",
  category: "multiuse-basket",

  short:
    "Ladle Cradle is a practical kitchen accessory designed to hold ladles, spoons, and spatulas while cooking. It helps keep countertops clean by collecting drips and preventing spills. Made from high-quality stainless steel, it ensures durability, hygiene, and a modern look for modular kitchens.",

  features: [
    "High-quality stainless steel construction",
    "Rust-resistant and long-lasting durability",
    "Keeps kitchen countertop clean and stain-free",
    "Compact and space-saving design",
    "Ideal for ladles, spoons, and spatulas",
    "Easy to clean and maintain"
  ],

  /* ✅ PRICE */
  price: "₹1188",
  oldPrice: "₹1200",

  /* ✅ SKU + STOCK */
  sku: "FLM 198",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET19,
  

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Ladle%20Cradle%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel" },
    { label: "Type", value: "Ladle Holder / Cradle" },
    { label: "Application", value: "Kitchen Countertop / Cooking Area" },
    { label: "Finish", value: "Nickel Chrome / Steel Finish" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Ladle Cradle", code: "FLM 198", size: "", finish: "Steel" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Laddle Craddle?",
      answer:
        "It is a kitchen accessory used to hold ladles, spoons, and spatulas while cooking."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used on kitchen countertops near cooking areas to keep utensils organized."
    },
    {
      question: "What is its main benefit?",
      answer:
        "It prevents spills and keeps the kitchen counter clean and hygienic."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality stainless steel for long-lasting use."
    },
    {
      question: "Is it easy to clean?",
      answer:
        "Yes, it can be easily cleaned with water or a damp cloth."
    }
  ]
},
  
{
  code: "MB-020",
  name: "KITCHEN KEEPER",
  category: "multiuse-basket",

  short:
    "Kitchen Keeper is a smart pull-out storage solution designed to keep kitchen essentials organized and easily accessible. With a smooth sliding mechanism and durable construction, it maximizes cabinet space and enhances convenience in modular kitchens.",

  features: [
    "Space-saving pull-out storage design",
    "Smooth sliding mechanism",
    "Strong and durable construction",
    "Organizes kitchen essentials efficiently",
    "Ideal for modular kitchen cabinets",
    "Easy to install and maintain"
  ],

  price: "₹3048",
  oldPrice: "₹3090",

  sku: "FLM 198",
  stock: "In Stock",

  mainImage: BASKET20,


  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Kitchen%20Keeper%20Inquiry",

  specifications: [
    { label: "Type", value: "Pull-Out Storage" },
    { label: "Material", value: "Metal / SS" },
    { label: "Application", value: "Kitchen Cabinet" }
  ],

  specTable: [
    { item: "Kitchen Keeper", code: "MB-020", size: "Standard", finish: "Standard" }
  ],

  faq: [
    { question: "What is a Kitchen Keeper?", answer: "It is a pull-out storage unit for organizing kitchen essentials." },
    { question: "Where can it be used?", answer: "In modular kitchen cabinets." },
    { question: "Main benefit?", answer: "Easy access and organized storage." },
    { question: "Is it durable?", answer: "Yes, made from strong materials." },
    { question: "Installation?", answer: "Easy with standard fittings." }
  ]
},



  {
  code: "MB-021",
  name: "SPOON HOLDER",
  category: "multiuse-basket",

  short:
    "Spoon Holder is a compact storage solution designed to organize spoons and small utensils neatly. It keeps your kitchen clean, organized, and ensures easy access during daily use.",

  features: [
    "Ideal for spoons and small utensils",
    "Compact and space-saving design",
    "Durable and rust-resistant material",
    "Keeps kitchen neat and organized",
    "Easy placement in drawers or cabinets"
  ],

  price: "₹1800",
  oldPrice: "₹2000",

  sku: "FLM 196",
  stock: "In Stock",

  mainImage: BASKET21,
  

  video: "https://www.youtube.com/embed/2Py1jFLG67U",
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Spoon%20Holder%20Inquiry",

  specifications: [
    { label: "Material", value: "Metal / SS" },
    { label: "Type", value: "Utensil Holder" },
    { label: "Application", value: "Drawer / Cabinet" }
  ],

  specTable: [
    { item: "Spoon Holder", code: "FLM 196", size: "", finish: "Steel" }
  ],

  faq: [
    { question: "What is a Spoon Holder?", answer: "Used to organize spoons and small utensils." },
    { question: "Where used?", answer: "Drawers and cabinets." },
    { question: "Benefit?", answer: "Keeps utensils organized." },
    { question: "Durable?", answer: "Yes." },
    { question: "Cleaning?", answer: "Easy to clean." }
  ]
},


  {
  code: "MB-022",
  name: "GLASS HOLDER",
  category: "multiuse-basket",

  short:
    "Glass Holder is designed to store glasses and cups safely inside cabinets. It prevents breakage, keeps items organized, and ensures easy access in modular kitchens.",

  features: [
    "Ideal for glasses and cups",
    "Prevents tipping and damage",
    "Durable and rust-resistant",
    "Space-saving design",
    "Easy access and organization"
  ],

  price: "₹1179",
  oldPrice: "₹2000",

  sku: "flm 191",
  stock: "In Stock",

  mainImage: BASKET22,


  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  catalogue: "/Slimline Price List-2026.pdf",
  inquiry: "https://wa.me/919650100908?text=Glass%20Holder%20Inquiry",

  specifications: [
    { label: "Material", value: "Metal / SS" },
    { label: "Type", value: "Glass Holder" },
    { label: "Application", value: "Cabinet / Shelf" }
  ],

  specTable: [
    { item: "Glass Holder", code: "FLM 191", size: "", finish: "Chrome" }
  ],

  faq: [
  {
    question: "What is a Glass Holder?",
    answer:
      "A Glass Holder is a storage accessory designed to safely hold and organize glasses, cups, and tumblers."
  },
  {
    question: "Where can it be used?",
    answer:
      "It can be used in kitchen cabinets, shelves, or modular storage units."
  },
  {
    question: "What are the benefits?",
    answer:
      "It keeps glasses organized, prevents breakage, and maximizes storage space."
  },
  {
    question: "Is it durable?",
    answer:
      "Yes, it is made from strong and durable materials for long-lasting use."
  },
  {
    question: "Is it easy to clean?",
    answer:
      "Yes, it can be easily cleaned with a cloth or mild detergent."
  }
]
},


 {
  code: "MB-023",
  name: "GTPT WIRE",
  category: "multiuse-basket",

  short:
    "GTPT Wire is a durable and versatile kitchen storage solution designed to organize utensils, containers, and daily essentials efficiently. Made from high-quality stainless steel wire with a rust-resistant finish, it ensures strength, ventilation, and long-lasting performance. Its open wire design provides better visibility and airflow, making it ideal for modular kitchen cabinets and storage units.",

  features: [
    "High-quality stainless steel wire construction",
    "Rust-resistant and long-lasting finish",
    "Open wire design for ventilation and visibility",
    "Strong and durable structure",
    "Ideal for storing utensils, jars, and containers",
    "Suitable for modular kitchen cabinets and racks",
    "Easy to clean and maintain"
  ],

  /* ✅ PRICE */
  price: "₹2280",
  oldPrice: "₹3000",

  /* ✅ SKU + STOCK */
  sku: "FLM 181-184",
  stock: "In Stock",

  /* ✅ IMAGES */
  mainImage: BASKET23,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=GTPT%20Wire%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Stainless Steel Wire" },
    { label: "Finish", value: "Nickel Chrome" },
    { label: "Type", value: "Wire Basket" },
    { label: "Application", value: "Kitchen Cabinet / Storage Rack" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "GTPT Wire", code: "MB-023", size: "-", finish: "Nickel Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a GTPT Wire?",
      answer:
        "GTPT Wire is a stainless steel wire storage basket used to organize kitchen items efficiently."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in kitchen cabinets, drawers, and modular storage units."
    },
    {
      question: "What are its benefits?",
      answer:
        "It improves organization, provides airflow, and allows easy access to stored items."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality rust-resistant stainless steel for long-term use."
    },
    {
      question: "Is it easy to maintain?",
      answer:
        "Yes, it can be easily cleaned with a cloth or mild detergent."
    }
  ]
},

  {
  code: "MB-024",
  name: "BIN HOLDER",
  category: "multiuse-basket",

  short:
    "Bin Holder is a practical and space-saving kitchen accessory designed to securely hold waste bins inside cabinets. It helps maintain cleanliness and hygiene by keeping bins neatly placed and easily accessible. Made from high-quality, durable materials, it ensures long-lasting performance and stability. Ideal for modular kitchens, it keeps your space organized and clutter-free.",

  features: [
    "Holds waste bin securely inside cabinet",
    "Strong and durable construction",
    "Space-saving and compact design",
    "Improves kitchen hygiene and cleanliness",
    "Prevents bin movement and spills",
    "Easy to install and use",
    "Suitable for modular kitchen cabinets"
  ],

  /* ✅ PRICE */
  price: "₹1038",
  oldPrice: "₹1500",

  /* ✅ SKU + STOCK */
  sku: "FLM 192",
  stock: "In Stock",

  /* ✅ IMAGE */
  mainImage: BASKET24,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Bin%20Holder%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal / Durable Plastic" },
    { label: "Type", value: "Bin Holder" },
    { label: "Finish", value: "Standard" },
    { label: "Application", value: "Kitchen Cabinet / Under Sink" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Bin Holder", code: "FLM 192", size: "-", finish: "Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Bin Holder?",
      answer:
        "Bin Holder is a kitchen accessory used to securely hold waste bins inside cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is commonly used under sinks or inside kitchen cabinets."
    },
    {
      question: "What are its benefits?",
      answer:
        "It keeps bins stable, prevents spills, and maintains kitchen cleanliness."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong and long-lasting materials."
    },
    {
      question: "Is it easy to install?",
      answer:
        "Yes, it can be easily installed using standard fittings."
    }
  ]
},
  {
  code: "MB-025",
  name: "UAE ME SHUTTER",
  category: "multiuse-basket",

  short:
    "UAE Me Shutter is a modern and efficient cabinet shutter system designed for modular kitchens and storage units. It offers a clean, stylish appearance along with smooth and reliable operation. Made from high-quality materials, it ensures durability, strength, and long-lasting performance. Ideal for contemporary interiors, it enhances both functionality and aesthetics of cabinets.",

  features: [
    "Modern and stylish shutter design",
    "Smooth and reliable opening and closing",
    "Strong and durable construction",
    "Enhances cabinet appearance",
    "Provides secure storage solution",
    "Suitable for modular kitchens and wardrobes",
    "Easy to operate and maintain"
  ],

  /* ✅ PRICE */
  price: "₹1311",
  oldPrice: "₹1500",

  /* ✅ SKU + STOCK */
  sku: "flm 189",
  stock: "In Stock",

  /* ✅ IMAGE */
 mainImage: BASKET25,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=UAE%20Me%20Shutter%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Metal / Composite" },
    { label: "Type", value: "Cabinet Shutter System" },
    { label: "Finish", value: "Standard" },
    { label: "Application", value: "Kitchen Cabinet / Wardrobe" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "UAE Me Shutter", code: "FLM 189", size: "", finish: "Chrome" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a UAE Me Shutter?",
      answer:
        "It is a cabinet shutter system designed for smooth and stylish opening and closing of modular cabinets."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in kitchen cabinets, wardrobes, and modular storage units."
    },
    {
      question: "What are its benefits?",
      answer:
        "It improves cabinet appearance, provides smooth operation, and ensures secure storage."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from high-quality materials for long-lasting performance."
    },
    {
      question: "Is it easy to use?",
      answer:
        "Yes, it is designed for smooth and effortless daily operation."
    }
  ]
},

 {
  code: "MB-026",
  name: "BUCKET BIN",
  category: "multiuse-basket",

  short:
    "Bucket Bin is a practical and durable storage solution designed for kitchens, bathrooms, and utility areas. It is ideal for storing waste, water, grains, and other household items in a clean and organized way. Made from high-quality material, it ensures strength, hygiene, and long-lasting performance. Its compact and functional design makes it perfect for modern modular spaces.",

  features: [
    "Strong and durable construction",
    "Suitable for waste, water, and storage use",
    "Compact and space-saving design",
    "Easy to clean and maintain",
    "Multipurpose usage for home and kitchen",
    "Lightweight and easy to handle",
    "Ideal for modular kitchens and utility areas"
  ],

  /* ✅ PRICE */
  price: "₹1038",
  oldPrice: "₹1200",

  /* ✅ SKU + STOCK */
  sku: "FLM 188",
  stock: "In Stock",

  /* ✅ IMAGE */
  mainImage: BASKET26,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Bucket%20Bin%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Plastic / Metal" },
    { label: "Type", value: "Storage Bin" },
    { label: "Finish", value: "Standard" },
    { label: "Application", value: "Kitchen / Bathroom / Utility" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Bucket Bin", code: "FLM 188", size: "", finish: "" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Bucket Bin?",
      answer:
        "Bucket Bin is a storage container used for waste, liquids, or bulk household items."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is used in kitchens, bathrooms, and utility areas."
    },
    {
      question: "What are its benefits?",
      answer:
        "It keeps items organized, prevents spills, and improves cleanliness."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong and long-lasting materials."
    },
    {
      question: "Is it easy to maintain?",
      answer:
        "Yes, it can be easily cleaned with water or a mild detergent."
    }
  ]
},
{
  code: "MB-027",
  name: "PADDLE PERFORATED",
  category: "multiuse-basket",

  short:
    "Paddle Perforated Basket is a stylish and durable storage solution designed for modular kitchens. Its perforated design allows proper airflow and helps keep kitchen essentials fresh and organized. Made from premium-quality material, it offers excellent strength, durability, and smooth performance. The modern paddle-style design adds convenience and enhances the overall look of kitchen interiors.",

  features: [
    "Modern perforated basket design",
    "Strong and durable construction",
    "Proper airflow for better hygiene",
    "Smooth and easy accessibility",
    "Ideal for modular kitchen storage",
    "Easy to clean and maintain",
    "Space-saving and functional design"
  ],

  /* ✅ PRICE */
  price: "₹2150",
  oldPrice: "₹2500",

  /* ✅ SKU + STOCK */
  sku: "FLM 190",
  stock: "In Stock",

  /* ✅ IMAGE */
  mainImage: BASKET27,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Paddle%20Perforated%20Basket%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Steel / Metal" },
    { label: "Type", value: "Perforated Basket" },
    { label: "Finish", value: "Chrome Finish" },
    { label: "Application", value: "Modular Kitchen" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Paddle Perforated", code: "FLM 190", size: "", finish: "" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is a Paddle Perforated Basket?",
      answer:
        "It is a perforated storage basket designed for organizing kitchen essentials efficiently."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is mainly used in modular kitchens and storage cabinets."
    },
    {
      question: "What are its benefits?",
      answer:
        "It improves storage organization and allows proper airflow inside the basket."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from premium-quality and long-lasting materials."
    },
    {
      question: "Is it easy to maintain?",
      answer:
        "Yes, it can be cleaned easily using a soft cloth or mild cleaner."
    }
  ]
},
{
  code: "MB-028",
  name: "HANGING CORNER (2 SHELF)",
  category: "multiuse-basket",

  short:
    "Hanging Corner (2 Shelf) is a practical and space-saving storage solution designed for modular kitchens and bathrooms. Its two-shelf corner design helps utilize unused corner spaces efficiently for storing bottles, containers, toiletries, and kitchen essentials. Made from high-quality material, it provides durability, strength, and long-lasting performance while adding a modern touch to interiors.",

  features: [
    "Two-shelf corner storage design",
    "Efficient use of corner space",
    "Strong and durable construction",
    "Ideal for kitchen and bathroom use",
    "Easy to install and maintain",
    "Modern and stylish appearance",
    "Perfect for organized storage"
  ],

  /* ✅ PRICE */
  price: "₹1650",
  oldPrice: "₹1950",

  /* ✅ SKU + STOCK */
  sku: "FLM 191",
  stock: "In Stock",

  /* ✅ IMAGE */
  mainImage: BASKET28,

  /* ✅ VIDEO */
  video: "https://www.youtube.com/embed/2Py1jFLG67U",

  /* ✅ LINKS */
  catalogue: "/Slimline Price List-2026.pdf",
  inquiry:
    "https://wa.me/919650100908?text=Hanging%20Corner%202%20Shelf%20Inquiry",

  /* ✅ SPECIFICATIONS */
  specifications: [
    { label: "Material", value: "Steel / Metal" },
    { label: "Type", value: "Corner Basket" },
    { label: "Finish", value: "Chrome Finish" },
    { label: "Application", value: "Kitchen / Bathroom" }
  ],

  /* ✅ SPEC TABLE */
  specTable: [
    { item: "Hanging Corner (2 Shelf)", code: "FLM 191", size: "", finish: "" }
  ],

  /* ✅ FAQ */
  faq: [
    {
      question: "What is Hanging Corner (2 Shelf)?",
      answer:
        "It is a two-level corner storage basket used for organizing household essentials."
    },
    {
      question: "Where can it be used?",
      answer:
        "It is commonly used in kitchens, bathrooms, and utility spaces."
    },
    {
      question: "What are its benefits?",
      answer:
        "It saves space, improves organization, and utilizes unused corners efficiently."
    },
    {
      question: "Is it durable?",
      answer:
        "Yes, it is made from strong and long-lasting materials."
    },
    {
      question: "Is it easy to maintain?",
      answer:
        "Yes, it can be cleaned easily with a soft cloth or mild cleaner."
    }
  ]
}
];
